import React from 'react';
import PropTypes from 'prop-types';
import { SortableElement } from 'react-sortable-hoc';
import { Icon } from 'antd';
import DragHandle from './DragHandle';
// import PopoverHandle from './PopoverHandle';
import styles from './index.less';

const typeEnum = {
  category: {
    name: 'Категори',
    alias: 'категори',
  },
  new: {
    name: 'Шинэ',
  },
  'category-structure': {
    name: 'Бүх категори 1',
  },
  'category-sub': {
    name: 'Дэд категори',
    alias: 'дэд категори',
  },
  cat: {
    name: 'Бүх категори 2',
  },
  type1: {
    name: 'Хямдралтай',
  },
  top: {
    name: 'Онцлох',
    readonly: true,
  },
  event: {
    name: 'Event',
    readonly: true,
  },
  banner: {
    name: 'Баннер',
    readonly: true,
  },
};

const SortableItem = props => (
  <div className={styles.stylizedItem}>
    {
      (props.item.type === 'category' || props.item.type === 'category-sub') ?
        `${props.item.relation.alias} ${typeEnum[props.item.type].alias}` :
        // 'asdd' :
        typeEnum[props.item.type].name
    }
    <div className={styles.catAction}>
      {/* <PopoverHandle onEdit={props.onEdit} item={props.item} onDelete={props.onDelete} /> */}
      {/* <Icon onEdit={props.onEdit} type="edit" /> */}
      {/* <Icon onDelete={props.onDelete} type="delete" /> */}
      {
        typeEnum[props.item.type].readonly ?
          null :
          <a className={styles.link} onClick={() => props.onDelete(props.item)}><Icon type="delete" /></a>
      }
      <DragHandle />
    </div>
  </div>
);

SortableItem.propTypes = {
  item: PropTypes.object.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default SortableElement(SortableItem);



// WEBPACK FOOTER //
// ./src/containers/Homepage/SortableItem.js